import { createRequest, composeRequestConfig } from '../core/utils/axios/api';
import { teamsEnv } from '../core/utils';
export var attachmentNew = function attachmentNew() {
  var url = "/attachments/new?react_api=true";
  var config = composeRequestConfig({
    url: url
  });
  return createRequest(config);
};
export var attachmentCreate = function attachmentCreate(payload) {
  var url = "/attachments?react_api=true";
  var config = composeRequestConfig({
    url: url,
    method: 'post',
    payload: payload
  });
  return createRequest(config);
};
export var attachmentDelete = function attachmentDelete(attachmentId) {
  var url = "/attachments/".concat(attachmentId, "?react_api=true");
  var config = composeRequestConfig({
    url: url,
    method: 'delete'
  });
  return createRequest(config);
};
export var attachmentShow = function attachmentShow(attachmentId) {
  var url = "/attachments/".concat(attachmentId, "?react_api=true");
  var config = composeRequestConfig({
    url: url
  });
  return createRequest(config);
};
export var download = function download(attachmentId) {
  var url = "/attachments/".concat(attachmentId, "/download?react_api=true");
  var config = composeRequestConfig({
    url: url
  });
  return createRequest(config);
};
export var update = function update(attachmentId, payload) {
  var url = "api/v1/ms_teams/".concat(teamsEnv.tenantId, "/channels/").concat(teamsEnv.channelId, "/annotations/").concat(attachmentId);
  var config = composeRequestConfig({
    url: url,
    payload: {
      data: payload
    },
    method: 'patch'
  });
  return createRequest(config);
};